export default __webpack_public_path__ + "static/media/developed.18a64c55.svg";